export const Roles = {
  Company: 'Company',
  Engineer: 'Engineer',
} as const;

export type Role = (typeof Roles)[keyof typeof Roles];

export const RoleRoutes: Record<Role, { section: string; sections: string[]; defaultRoute: string; routes: string[] }> = {
  [Roles.Company]: {
    section: 'BtakkaErp',
    sections: ['BtakkaInterface', 'BtakkaErp', 'BtakkaOperation'],
    defaultRoute: 'Account',
    routes: ['Account', 'Cost-Center', 'Journal-Type'],
  },
  [Roles.Engineer]: {
    section: 'BtakkaOperation',
    sections: ['BtakkaOperation'],
    defaultRoute: 'Operation',
    routes: [
      'Operation', 'Operation/:tab', 'Settling', 'SettlementDetails/:id', 'Management',
      'EngineersBalance', 'UnitsBalance', 'UnitDashboard/:id', 'ImpressSettlement/:id/:tab',
      'EngineerDetails/:id/:tab', 'StatementExpenses/:id', 'StatementExpensesDetails/:id/:index',
      'AccountStatement/:id',
    ],
  },
};

export const RolePermissions: Record<Role, string[]> = {
  [Roles.Company]: [
    'viewAccounts',
    'viewCostCenters',
    'viewJournalTypes',
    'manageUsers',
  ],
  [Roles.Engineer]: [
    'viewOperations',
    'viewUnits',
    'viewSettlements',
    'viewStatements',
    'downloadPDF',
  ],
};
